import { mapGetters } from 'vuex';

export default {
    name: 'searchRelatedLinks',
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('msp', ['msp', 'geo', 'noFilter', 'getGeoDisplayText']),
        getRelatedLinks() {
            const searchType = this.geo.neighborhood ? 'neighborhood' : (this.geo.zipcode ? 'zipcode' : 'city')
            const demographicName = this.getGeoDisplayText;
            const mspUrl = this.generateMapSearchUrl(this.glb.appUrl, {
                type: searchType,
                cityName: this.geo.city,
                stateCode: this.geo.stateCode,
                neighborhood: this.geo.neighborhood,
                zipcode: this.geo.zipcode,
                filterArray: ['condo','singleFamily'],
                listingCountObj: this.glb.listingCountObj
            });

            return {
                demographicName,
                baseUrl: mspUrl.base,
                data: [
                    ...(this.msp.relatedLinks.zumperMspUrl ? [{
                        text: `${demographicName} ${this.molang('search.common.apartments')} ${this.molang('search.common.forRent')}`,
                        target: '_blank',
                        link: this.msp.relatedLinks.zumperMspUrl
                    }]: []),
                    ...(mspUrl.filteredUrlObj.condoCount ? [{
                        text: `${demographicName} ${this.molang('search.common.condoForSale')}`,
                        link: mspUrl.filteredUrlObj.condo
                    }] : []),
                    ...(mspUrl.filteredUrlObj.singleFamilyCount ? [{
                        text: `${demographicName} ${this.molang('search.common.homesForSale')}`,
                        link: mspUrl.filteredUrlObj.singleFamily
                    }] : []),
                    {
                        text: this.molang('search.advantage.homes'),
                        link: this.glb.appUrl + 'for-sale/'
                    }
                ]
            };
        }
    }
};
